import { inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

export abstract class AbstractSanitizePipe {
  protected readonly sanitizer = inject(DomSanitizer);
}
